export default __webpack_public_path__ + "2b835e8f3de7e07f14a8662f8479197d.png";